
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 21","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.775 15.983a16.061 16.061 0 01-.821-1.21 7.297 7.297 0 001.38-4.274A7.333 7.333 0 1010 17.832c1.101 0 2.141-.254 3.08-.69.91.435 1.755.636 2.868.876.923.198 1.698-.835 1.097-1.664-.091-.127-.182-.25-.27-.37zm-2.14-1.675l-.28.341.204.391.07.132s.597.948.92 1.39c-.851-.195-1.47-.379-2.153-.74l-.31-.165-.31.163a6 6 0 111.86-1.511z"}}),_c('path',{attrs:{"d":"M8.334 9.082h3.333a.667.667 0 100-1.333H8.334a.666.666 0 100 1.333zM12.5 10.668h-5A.666.666 0 107.5 12h5a.667.667 0 000-1.333z"}})])
          )
        }
      }
    